import React, { useState, useEffect, useRef } from "react";

import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { i18n } from "../../translate/i18n";
import { Stack } from "@mui/material";
import { MessageSquareText } from "lucide-react";
import ChatiaDialog from "../ChatiaDialog";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  content: {
    gap: 12,
    display: "flex",
    flexDirection: "column",
  },
  infoCard: {
    background: theme.mode === "dark" ? "#16191f" : "#ffffff",
    color: theme.mode === "dark" ? "#e9edef" : "#111b21",
    border: theme.mode === "dark" ? "1px solid rgba(255, 255, 255, 0.08)" : "1px solid rgba(15, 23, 42, 0.10)",
    borderRadius: 12,
    padding: 16,
    boxShadow: "0 10px 28px rgba(0, 0, 0, 0.16)",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 14,
    color: theme.mode === "dark" ? "#e9edef" : "#111b21",
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: 0.1,
  },
  cardIcon: {
    width: 32,
    height: 32,
    borderRadius: 10,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: theme.mode === "dark" ? "rgba(255, 255, 255, 0.06)" : "rgba(15, 23, 42, 0.04)",
    border: theme.mode === "dark" ? "1px solid rgba(255, 255, 255, 0.08)" : "1px solid rgba(15, 23, 42, 0.10)",
    color: theme.palette.primary.main,
    "& svg": {
      color: theme.palette.primary.main,
      stroke: theme.palette.primary.main,
    },
  },
  textField: {
    width: "100%",
  },
}));

const FlowBuilderAddTextModal = ({ open, onSave, onUpdate, data, close }) => {
  const classes = useStyles();
  const isMounted = useRef(true);

  const [activeModal, setActiveModal] = useState(false);

  const [labels, setLabels] = useState({
    title: i18n.t("flowBuilderModals.textModal.titleAdd"),
    btn: i18n.t("flowBuilderModals.textModal.buttonAdd")
  });

  const [textDig, setTextDig] = useState();

  useEffect(() => {
    if (open === "edit") {
      setLabels({
        title: i18n.t("flowBuilderModals.textModal.titleEdit"),
        btn: i18n.t("flowBuilderModals.textModal.buttonSave")
      });
      setTextDig(data.data.label);
      setActiveModal(true);
    } else if (open === "create") {
      setLabels({
        title: i18n.t("flowBuilderModals.textModal.titleAdd"),
        btn: i18n.t("flowBuilderModals.textModal.buttonAdd")
      });
      setTextDig("");
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleClose = () => {
    close(null)
    setActiveModal(false);
  };

  const handleSaveContact = async () => {
    if (open === "edit") {
      handleClose();
      onUpdate({
        ...data,
        data: { label: textDig }
      });
      return;
    } else if (open === "create") {
      handleClose();
      onSave({
        text: textDig
      });
    }
  };

  const CardTitle = ({ icon: Icon, children }) => (
    <div className={classes.cardHeader}>
      <span className={classes.cardIcon}>
        <Icon size={16} />
      </span>
      <span>{children}</span>
    </div>
  );

  return (
    <div className={classes.root}>
      <ChatiaDialog
        open={activeModal}
        onClose={handleClose}
        title={labels.title}
        maxWidth="md"
        contentDividers={false}
        onSave={handleSaveContact}
        saveType="button"
        saveText={labels.btn}
      >
        <Stack className={classes.content}>
          <Stack className={classes.infoCard}>
            <CardTitle icon={MessageSquareText}>
              {i18n.t("flowBuilderModals.textModal.fields.message")}
            </CardTitle>
            <TextField
              label={i18n.t("flowBuilderModals.textModal.fields.message")}
              multiline
              minRows={7}
              name="text"
              variant="outlined"
              value={textDig}
              margin="dense"
              onChange={e => setTextDig(e.target.value)}
              className={classes.textField}
            />
          </Stack>
        </Stack>
      </ChatiaDialog>
    </div>
  );
};

export default FlowBuilderAddTextModal;
